export class Locale {
  constructor(public id = '1', public displayLabel = 'English (US)', public localeName = 'en_US') {}
}
